import React, { useEffect, useState } from "react"
import { Box, Button, Grid, Paper, TextField, Typography } from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import { useSnackbar } from "../../../utils/notificacoes"
import { obterRepediu, salvarRepediu } from "../../../services/integracaoParceiros"
import useLoadingStore from "../../../stores/LoadingStore"
import { useIntegracaoStyles } from "../../../utils/integracaoParceirosStyles"

export function IntegracaoRepediuForm() {
    const classes = useIntegracaoStyles()
    const { enqueueSnackbar } = useSnackbar()
    const setLoading = useLoadingStore(s => s.setLoading)

    const [codigoRepediu, setCodigoRepediu] = useState("")
    const [chaveRepediu, setChaveRepediu] = useState("")

    const alertStart = (msg: string, tipo: "success" | "error" | "info") =>
        enqueueSnackbar(msg, { variant: tipo })

    useEffect(() => {
        const carregar = async () => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            setLoading(true)
            try {
                const res = await obterRepediu(autorizacao)
                if ("retornoErro" in res) {
                    alertStart(res.mensagem || "Erro ao carregar integração", "error")
                } else {
                    setCodigoRepediu(res.codigoRepediu ?? "")
                    setChaveRepediu(res.chaveRepediu ?? "")
                }
            } finally {
                setLoading(false)
            }
        }
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSalvar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        if (!codigoRepediu.trim() || !chaveRepediu.trim()) {
            alertStart("Preencha o código e a chave Repediu.", "error")
            return
        }
        setLoading(true)
        try {
            const res = await salvarRepediu(autorizacao, { codigoRepediu, chaveRepediu })
            if ("retornoErro" in res) {
                alertStart(res.mensagem || "Erro ao salvar", "error")
            } else {
                setCodigoRepediu(res.codigoRepediu ?? "")
                setChaveRepediu(res.chaveRepediu ?? "")
                alertStart("Parâmetros salvos com sucesso!", "success")
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box className={classes.container}>
            <Box className={classes.content}>
                <Typography variant="h5" className={classes.titleText}>
                    Integração Repediu
                </Typography>

                <Paper className={classes.configCard}>
                    <Box className={classes.cardHeader}>
                        <Typography variant="h6" className={classes.cardHeaderTitle}>
                            Parâmetros Repediu
                        </Typography>
                    </Box>
                    <Box className={classes.cardContent}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Código Repediu"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={codigoRepediu}
                                    onChange={e => setCodigoRepediu(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Chave Repediu"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={chaveRepediu}
                                    onChange={e => setChaveRepediu(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>

                <Box display="flex" justifyContent="center" mb={4}>
                    <Button
                        className={classes.saveButton}
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={handleSalvar}
                    >
                        Salvar
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}
